import { NullableNumber } from '_/types/common.types';

const formatPercentage = (value: NullableNumber | undefined): number => (value ? Number.parseFloat(value.toFixed(3)) : 0);

export default formatPercentage;
